import type { ReactNode } from 'react';

export const symbol_horizontal_align_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M128.5-168.5Q120-177 120-190v-580q0-13 8.5-21.5T150-800q13 0 21.5 8.5T180-770v580q0 13-8.5 21.5T150-160q-13 0-21.5-8.5ZM356-450l96 96q9 9 8.5 21t-9.5 21q-9 9-21.5 9t-21.5-9L261-459q-5-5-7-10t-2-11q0-6 2-11t7-10l152-152q9-9 21.5-8.5T456-652q9 9 9 21.5t-9 21.5l-100 99h454q13 0 21.5 8.5T840-480q0 13-8.5 21.5T810-450H356Z"
		/>
	</svg>
);
